/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/home': {
    width: 24,
    height: 23,
    viewBox: '0 0 24 23',
    data: '<path pid="0" d="M10.018 18.362v4.108H3.456v-6.01a4 4 0 011.048-2.7L9.64 8.143a4 4 0 015.92.017l5.012 5.544a4 4 0 011.033 2.683v6.083h-6.357v-4.108a2.615 2.615 0 00-5.23 0z" _fill="#fff"/><path pid="1" d="M10.375 5.018a3 3 0 014.446.012l7.673 8.514a.859.859 0 101.275-1.15L14.12 1.7a2.08 2.08 0 00-3.08-.01L8.531 4.433a.637.637 0 01-1.107-.43.637.637 0 00-.638-.637H5.531A1.892 1.892 0 003.64 5.258v3.746c0 .51-.189 1.003-.53 1.382l-1.794 1.986a.872.872 0 001.29 1.171l7.77-8.525z" _fill="#fff"/>'
  }
})
